var _circle, _ellipse, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserdefult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 90,
    viewBox: "0 0 89 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 45,
    r: 44.5,
    fill: "#C4C4C4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.849,
    cy: 65.0248,
    rx: 34.2846,
    ry: 24.475,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.3078 28.6834C62.3078 37.3746 54.5375 44.5 44.8492 44.5C35.1609 44.5 27.3906 37.3746 27.3906 28.6834C27.3906 19.9921 35.1609 12.8667 44.8492 12.8667C54.5375 12.8667 62.3078 19.9921 62.3078 28.6834Z",
    fill: "white",
    stroke: "#C0C0C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1366 9.32726C40.089 10.3161 38.4428 9.56729 45.2589 7.48558C50.1567 5.98973 52.8777 10.4397 53.83 9.32723L57.5021 11.6849C56.6098 10.9738 56.5027 10.4522 56.5027 10.4522L58.7278 12.472C59.547 12.9066 60.665 13.3635 62.1896 13.7897C67.4955 15.2731 68.7199 18.6105 68.7199 18.6105C68.7199 18.6105 68.7199 27.4981 63.6256 28.623C53.3301 30.8966 37.2924 22.6897 37.2924 22.6897C36.3401 21.33 33.7823 18.7589 31.1702 19.3522C28.558 19.9455 30.1574 30.5373 29.5376 34.5564C28.9178 38.5754 24.2316 30.1064 24.2316 28.623C24.2316 27.1397 22.8711 20.3411 24.2316 16.3855C25.0479 13.6661 27.0887 11.5647 33.2109 10.4522C35.132 10.1031 36.5517 6.97864 39.1366 9.32726Z",
    fill: "white",
    stroke: "#C0C0C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4456 43.7623C34.718 48.5923 41.4432 49.3825 47.3907 48.3214C52.7959 47.3571 57.5634 44.865 60.8 42.493C59.3791 45.4709 57.5837 48.5282 55.5207 51.1901C53.0162 54.4216 50.1498 57.0281 47.1176 58.2375C44.1205 59.433 40.933 59.2782 37.6757 56.9314C34.6236 54.7324 31.4885 50.5912 28.4456 43.7623ZM27.0454 42.3973L27.6039 41.768C34.0287 47.4698 41.0388 48.4388 47.215 47.3369C53.4117 46.2314 58.7623 43.0391 61.7821 40.4404L62.1083 40.8194L62.5675 41.0171C61.0175 44.6187 58.8713 48.4993 56.3111 51.8027C53.7566 55.0986 50.7572 57.8624 47.4881 59.1664C44.1839 60.4844 40.6347 60.2958 37.0912 57.7427C33.5813 55.2139 30.1039 50.3865 26.8105 42.4953L27.0454 42.3973Z",
    fill: "#C0C0C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserdefult);
export default __webpack_public_path__ + "static/media/userdefult.88ec15347e460a921fbcc83594afcf96.svg";
export { ForwardRef as ReactComponent };